import { keycapRotationTransform } from '../../../utils/layoutGeometry';

// The clickable shadow image of one keycap, at the keycap's grid position and turned by its
// rotation: one component for the 20 keycap types below, which differ in their size alone
// (backfill PR 26 folded their 20 copies into it). A click selects the keycap in the
// customizer; the layout, colour and legends editors and order processing pass no click
// handler, so a click does nothing there (the editor flags the two StaticKeycapShadows still
// pass are not read).
const KeycapShadow = ({
  rowIndex,
  keycapIndex,
  xPosForKeycap,
  yPosForRow,
  keycap,
  imageDataUrl,
  handleKeycapClick,
  width,
  height,
}) => {
  return (
    <svg>
      <image
        href={imageDataUrl}
        x={xPosForKeycap}
        y={yPosForRow}
        transform={keycapRotationTransform(keycap)}
        width={width}
        height={height}
        style={{
          pointerEvents: 'all',
          cursor: 'pointer',
        }}
        onClick={(event) => {
          if (!handleKeycapClick) return; // the editors pass null and order processing nothing (the 20 copies checked the editors' flags and threw in order processing)
          handleKeycapClick(rowIndex, keycapIndex)(event);
        }}
      />
    </svg>
  );
};

export const OneUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="19.05" height="19.05" />
);

export const OneUnitHomingBarKeycapShadow = (props) => (
  <KeycapShadow {...props} width="19.05" height="19.05" />
);

export const OnePointFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="28.575" height="19.05" />
);

export const OnePointTwoFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="23.812" height="19.05" />
);

export const OnePointSevenFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="33.337" height="19.05" />
);

export const OneTimesTwoUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="19.05" height="38.1" />
);

export const TwoPointTwoFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="42.862" height="19.05" />
);

export const TwoPointSevenFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="52.388" height="19.05" />
);

export const TwoUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="38.1" height="19.05" />
);

export const ISOEnterKeycapShadow = (props) => (
  <KeycapShadow {...props} width="28.575" height="38.1" />
);

export const OnePointSevenFiveUnitSteppedKeycapShadow = (props) => (
  <KeycapShadow {...props} width="33.337" height="19.05" />
);

export const ConvexOneUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="19.05" height="19.05" />
);

export const ConvexOnePointTwoFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="23.812" height="19.05" />
);

export const ConvexOnePointSevenFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="33.337" height="19.05" />
);

export const ConvexTwoUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="38.1" height="19.05" />
);

export const ConvexTwoPointTwoFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="42.862" height="19.05" />
);

export const ConvexTwoPointSevenFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="52.388" height="19.05" />
);

export const ConvexThreeUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="57.15" height="19.05" />
);

export const ConvexSixPointTwoFiveUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="119.062" height="19.05" />
);

export const ConvexSevenUnitKeycapShadow = (props) => (
  <KeycapShadow {...props} width="133.35" height="19.05" />
);
